import { ApiClient } from './ApiClient';

export default class SoftwareTrackersConfigApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/software-trackers-config';

  public async getIsPublishedStatus(softwareId: number): Promise<boolean> {
    const response = await this.get(`${this.BASE_URL}/published-status?softwareId=${softwareId}`);
    return response.data;
  }

  public async publish(preview: boolean = false, softwareId: number = 0) {
    return await this.post(this.BASE_URL, {
      softwareId,
      preview,
    });
  }
}
